import { render, staticRenderFns } from "./revisaoCampos.vue?vue&type=template&id=4ce3b290"
import script from "./revisaoCampos.ts?vue&type=script&lang=js&external"
export * from "./revisaoCampos.ts?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/1/s/TafStore.PharmUP.Client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4ce3b290')) {
      api.createRecord('4ce3b290', component.options)
    } else {
      api.reload('4ce3b290', component.options)
    }
    module.hot.accept("./revisaoCampos.vue?vue&type=template&id=4ce3b290", function () {
      api.rerender('4ce3b290', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/parent/venda/revisaoCampos.vue"
export default component.exports